import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CircleManageRoute extends DiscourseRoute {
  showFooter = true;

  titleToken() {
    return i18n("discourse_circles.circle.manage.title_token", {
      circle_name: this.modelFor("circle").name,
    });
  }

  model() {
    return this.modelFor("circle");
  }

  serialize(model) {
    return { name: model.get("name").toLowerCase() };
  }
}
